import React from "react";
import SendNotification from "./SendNotification";
import ViewNotifications from "./ViewNotifications";
import ManageStaff from "./ManageStaff";
import ManagePrograms from "./ManagePrograms";
import ManageFamilies from "./ManageFamilies";
import Page from "~/shared/Page";
import { setSessionData } from "~/shared/utils";
import Dashboard from "~/shared/Dashboard";
import ManageAdmins from "./ManageAdmins";

export default function AdminDashboard() {
    const sections = [
        { title: "Send Notification", path: "send-notification", component: SendNotification, description: "Send emails/SMS to staff & families." },
        { title: "View Notifications", path: "view-notifications", component: ViewNotifications, description: "View sent notifications.", large: true },
        { title: "Manage Programs", path: "manage-programs", component: ManagePrograms, description: "View & edit programs.", large: true },
        { title: "Manage Families", path: "manage-families", component: ManageFamilies, description: "Search & edit families/children.", large: true },
        { title: "Manage Staff", path: "manage-staff", component: ManageStaff, description: "View & edit staff members.", large: true },
        { title: "Manage Admins", path: "manage-admins", component: ManageAdmins, description: "View & edit admins.", large: true },
    ];

    const currentSection = Dashboard.useCurrentSection("/admin", sections);

    if (!currentSection) {
        setSessionData("manage-families-state", undefined);
    }

    return (
        <Page title="Admin Dashboard" documentTitle={currentSection?.title ?? "Admin Dashboard"} className="admin-bg">
            <div className="scrolling-container">
                <Dashboard root="/admin" sections={sections} />
            </div>
        </Page>
    );
}